
import { Component, Vue, Prop, Emit, Watch } from "vue-property-decorator";
import { isMobile, isTablet } from "mobile-device-detect";
import { CommunityFutureHomePlans, CommunityQmiDetails, FutureHome, HeaderData, LotCountNeighborhood, NeighboorhoodCoords, NeighborhoodInfo, NeighborhoodPlanQmiCounts, NeighborhoodPlatMap, NeighborhoodSoldDetails, QmiDays, QmiDetails, SidebarHomePlan } from "./../types";
import { FutureData, HomePlanSortOptions, QmiDaysFilter, Settings, SortOptions } from "./../constant";
import SidebarPlanList from "./SideBarPlanList.vue";
import { apiMessages } from "./../api/message-api";
import Header from "./AppHeader.vue";
import { compareSortingValue, formatPrice, dateDiffInDays} from "@/core";
import LeftArrowIcon from "@/assets/icons/LeftArrow.vue";
// import {communityAllHomePlans}  from "@/constant"
@Component({
  components: {
    SidebarPlanList,
    Header,
    LeftArrowIcon
  },
})
export default class PlatmapSidebar extends Vue {
  private siderBarHeight = 0;
  private toolbarTopPosition = 0;
  private filterQmiCount = 0;
  private listHomeType = [] as string[];
  private listPlanName = [] as string[];
  private qmiDaysMobileFilter=[] as QmiDays[];
  private qmiAndHomeplans = [] as any[];
  private filterQmiAndHomePlans = [] as any[];
  private listPlanId = [] as string[]
  private maxPrice = 0;
  private minPrice = 0;
  private showFilters=false;
  private selectedNeighborhoodQmiDetails=[] as any[];
  private uniqueQmiCount = 0;
  private availablePlans = 0;
  messages: any = {};
  sortBy = SortOptions.PRICE;
  sortDir = -1;
  selectedSorting = "Price High to Low";
  isDeviceMobile = false;
  private hasMobile = !!(isMobile && !isTablet);
  private qmiAppliedMobile = false;
  private homeTypeCount = 0;
  private planPriceExsist = true;
  @Prop() notReservedPlan: string[];
  @Prop() coordinates: NeighborhoodPlatMap[];
  @Prop() private selectedJobNum!: string
  @Prop() private qmiDetails!:CommunityQmiDetails;
  @Prop() headerOpen!: boolean;
  @Prop() headerData!: HeaderData;
  @Prop() footerOpen!: boolean;
  @Prop() sidebarOpen!: boolean;
  @Prop() homeplans!: SidebarHomePlan[];
  @Prop() selectedHomePlanIds!: string[];
  @Prop() selectedHomePlanId!: string;
  @Prop() selectedLotId!: string;
  @Prop() selectedLotStatus!: string;
  @Prop() availableSites!: number;
  @Prop() availableLots!: number;
  @Prop() neighborhoodId!: string;
  @Prop() isKioskMode!: boolean;
  @Prop() soldPercentage!: NeighborhoodSoldDetails[];
  @Prop() neighborhoods!: NeighborhoodInfo[];
  @Prop() selectedNeighborhoodIds!: string[];
  @Prop() neighborhoodsPlanQmiCount!: NeighborhoodPlanQmiCounts[];
  @Prop() communityHomePlans!: SidebarHomePlan[];
  @Prop() initialHomePlanCount!: number;
  @Prop() totalMobileFilterApplied!: number;
  @Prop() futureHomePlans!: CommunityFutureHomePlans;
  @Prop() planAttachedFutureLot!: Set<string>;
  @Prop() private lotsCount!: LotCountNeighborhood[];
  @Prop() private svg!: string
  @Emit("toggleSidebar") toggleSidebar() {}
  @Emit("closeLotInfo") closeLotInfo() {}
  @Emit("updateNewHomePlanCount")updateNewHomePlanCount(lotId: string){}
  @Emit("sethoverNeighborZoomLevel")sethoverNeighborZoomLevel(zoomLevel: number, isDisableHoverNeighbor: boolean, centerMap: NeighboorhoodCoords){}
  @Emit("setHomePlanId") setHomePlanId(planId: string) {}
  @Emit("loadNeighborhood") loadNeighborhood(
    areaName: string,
    communityName: string,
    neighborhoodName: string
  ) {}
  @Emit("applyMobileFilters")applyMobileFilters(listPlanName:string[],listHomeType:string[],qmiFilterList:QmiDays[]){}
  @Emit("hideSibling")hideSibling(){}
  @Emit("selectNeighborhood") selectNeighborhood(neighborhoodId: string) { }
  @Emit("updatefilteredHomePlans")updatefilteredHomePlans(qmiAndHomeplans:any[]){}
  @Emit("setPlanNameListId") setPlanNameListId(listPlanId: string[]) {this.listPlanId=listPlanId.slice(0);}
  @Emit("clearSelectedNeighborhoods") clearSelectedNeighborhoods() {}
   constructor() {
    super();
    this.loadMessages();
  }
  @Emit("CleanHomeId")CleanHomeId(){}
  @Emit("setplanPriceExsist") setplanPriceExsist(planPriceExsist: boolean){}
  @Emit("applyMobilePriceFilter") applyMobilePriceFilter(minValue: number,maxValue: number){}
  @Emit("setPlanDetailsHometypeList")setPlanDetailsHometypeList(communityHomePlans: SidebarHomePlan[],homeTypeList: Set<string>, minPrice: number,maxPrice: number){}
    async loadMessages() {
      const { messages } = await apiMessages("Sidebar");
      this.messages = messages;
    }
  @Emit('setHomeTypeCount') setHomeTypeCount(homeTypeCount: number){} 
  @Emit("setFilterProperties") setFilterProperties(listHomeType: string[], listPlanName: string[], maxPrice: number, minPrice: number) {}
  @Emit('setSortProperties') setSortProperties(sortBy: string) {}
  @Emit('setQmiFilterProperties') setQmiFilterProperties(qmiFilterList: QmiDays[]) {}
  @Emit('highlightNeighborhood')highlightNeighborhood(neighborhoodId: string, display: string){}
  toggleshowFilters(){
    this.showFilters = !this.showFilters
  }

  checkHomeTypeCount (){
    const differentHomeType = new Set();
    this.qmiAndHomeplans.forEach((plan) => differentHomeType.add(plan.plan_type));
    this.homeTypeCount = differentHomeType.size;
    this.setHomeTypeCount(this.homeTypeCount);
  }
  priceExsist () {
   return !this.qmiAndHomeplans.find((plan) => plan.price ?? plan.price_low_with_premium);
  }

  futurePlanData(plan: any, futureHome: FutureHome){
    const futurePlanData = {};
    futurePlanData[FutureData.PLAN_MARKET_NAME] = plan.plan_name;
    futurePlanData[FutureData.PLAN_NAME] = plan.plan_name;
    futurePlanData[FutureData.PRICE] = plan.price_low_with_premium;
    futurePlanData[FutureData.ELEVATION] = futureHome.elevation;
    futurePlanData[FutureData.IMAGE] = [plan.thumbnail_img];
    futurePlanData[FutureData.ADDRESS] = futureHome.address;
    futurePlanData[FutureData.IS_FUTURE_PLAN] = true;
    futurePlanData[FutureData.JOB_NUMBER] = futureHome.job_number
    futurePlanData[FutureData.NEIGHBORHOOD_CODE] = plan.neighborhood_code;
    futurePlanData[FutureData.PLAN_TYPE] = plan.plan_type;
    futurePlanData[FutureData.FUTURE_ID] = plan.plan_id;
    futurePlanData[FutureData.NEIGHBORHOOD_NAME] = plan.neighborhoods.find(neighbor => neighbor.neighborhood_code === plan.neighborhood_code).neighborhood_name;
          return futurePlanData;
  }
  addFutureHomePlan(){
    const allFutureHomePlan = [] as FutureHome[];
    if(this.selectedNeighborhoodIds.length){
      allFutureHomePlan.push(...this.futureHomePlans[this.selectedNeighborhoodIds[0]])
    }else{     
      Object.values(this.futureHomePlans).forEach(futurePlan => allFutureHomePlan.push(...futurePlan));
    }
    allFutureHomePlan.forEach((element) => {
        const plan = this.qmiAndHomeplans.find(plan => plan.plan_name.toUpperCase() === element.plan_name.toUpperCase() && !plan.job_number);
        if(plan){
          element.plan_id = plan.plan_id;
          this.qmiAndHomeplans.push(this.futurePlanData(plan, element))
        }
      });
  }
  compareQmiFuturePlanSvgData(container){
    Object.keys(this.qmiDetails).forEach(qmiDetail => {
      const qmiPlans = [] as QmiDetails[];
      this.qmiDetails[qmiDetail].forEach(plan => {
        if(container.querySelectorAll(`#${plan.job_number}`).length){
          qmiPlans.push(plan);
        }
      })
      this.qmiDetails[qmiDetail] = qmiPlans;
    })
    Object.keys(this.futureHomePlans).forEach(futurePlan => {
      const futurePlanData = [] as FutureHome[];
      this.futureHomePlans[futurePlan].forEach(plan => {
        if(container.querySelectorAll(`#${plan.job_number}`).length){
          futurePlanData.push(plan);
        }
      })
      this.futureHomePlans[futurePlan] = futurePlanData;
    })
  }

  fixPlan(){
    const container = document.createElement('div');
    container.innerHTML = this.svg;
    this.compareQmiFuturePlanSvgData(container);
  }
  @Watch("selectedNeighborhoodIds",{immediate:true,deep:true})onChangeselectedNeighborhoodIds()
  {
    this.selectedNeighborhoodQmiDetails = [] as any[];
    this.fixPlan();
    if(!this.selectedNeighborhoodIds.length)
    {
      for(const key of Object.keys(this.qmiDetails))
      {
        this.selectedNeighborhoodQmiDetails.push(...this.qmiDetails[key]);
      }
    }
    this.selectedNeighborhoodIds.forEach((neighborhoodId)=>
    {
      this.selectedNeighborhoodQmiDetails.push(...this.qmiDetails[neighborhoodId]);
    })
    this.qmiAndHomeplans = (this.selectedNeighborhoodQmiDetails) ? this.homeplans.concat(this.selectedNeighborhoodQmiDetails) : this.homeplans;
    this.addFutureHomePlan();
    this.planPriceExsist = this.priceExsist();
    this.setplanPriceExsist(this.planPriceExsist);   
    this.checkHomeTypeCount();
  }

  mounted() {
    if (navigator.userAgent.match(/Android/i)
         || navigator.userAgent.match(/webOS/i)
         || navigator.userAgent.match(/iPhone/i)
         || navigator.userAgent.match(/iPod/i)
         || navigator.userAgent.match(/BlackBerry/i)
         || navigator.userAgent.match(/Windows Phone/i)) {
           this.isDeviceMobile = true;
        }
    this.calculateDynamicHeight();
  }

  updateCountQmi(){
    this.filterQmiCount = 0;
    const uniqueQmi = new Set();
    this.filterQmiAndHomePlans.forEach((element)=> {
      if(element.price>=0){
        uniqueQmi.add(element.plan_market_name);
        this.filterQmiCount ++;
      }
    })
    this.uniqueQmiCount = uniqueQmi.size;
  }

  getFuturePlanIds(){
    const futureplanIds = [] as string[];
    Object.values(this.futureHomePlans).forEach(plans => {
      const ids = plans.map(plan => plan.plan_id);
      futureplanIds.push(...ids);
    })
    return futureplanIds;
  }

  countNewHomePlans(availablePlanCount: number){
    this.availablePlans = availablePlanCount- this.filterQmiCount;
    const futurePlanIds =  this.getFuturePlanIds();
    futurePlanIds.forEach(planId => {
      this.updateNewHomePlanCount(planId);
    })
  }
  separateCommunityPlans(){
    this.qmiAndHomeplans.forEach((plan) => {
      if(this.selectedNeighborhoodIds.includes(plan.neighborhood_code)) {
        this.filterQmiAndHomePlans.push(plan);
      } else if(this.selectedNeighborhoodIds.length && plan.neighborhoods) {
        let planNeighborhoods = [] as string[];
        plan.neighborhoods.forEach((neighborhood) => {
          planNeighborhoods.push(neighborhood.neighborhood_code);
        });
        planNeighborhoods.includes(this.selectedNeighborhoodIds[0]) ? this.filterQmiAndHomePlans.push(plan) : '';
      }
    });
  }
  sortByPrice(){
    if (this.availableSites && this.sortBy === SortOptions.PRICE) {
      let plansWithoutPrice = this.filterQmiAndHomePlans.filter((plan) => !(plan.price ?? plan.price_low_with_premium));
      let plansWithPrice = this.filterQmiAndHomePlans.filter((plan) => plan.price ?? plan.price_low_with_premium);
      plansWithoutPrice = this.sortPlans(plansWithoutPrice, SortOptions.PLAN, 1);
      plansWithPrice = this.sortPlans(plansWithPrice, this.sortBy, this.sortDir);
      this.filterQmiAndHomePlans = plansWithPrice.concat(plansWithoutPrice);
    } else {
      this.filterQmiAndHomePlans = this.sortPlans(this.filterQmiAndHomePlans, this.sortBy, this.sortDir);
    }
  }
  get sortedhomePlans(){
    this.filterQmiAndHomePlans = [] as any;
    if(this.hasMobile && this.qmiDaysMobileFilter.length){
      this.applyQmiDaysFilter(this.qmiDaysMobileFilter);
    }else if(this.hasMobile){
      this.showQmiHomeplans(false);
    }
    if(!this.selectedNeighborhoodIds.length)
    {
      Object.assign(this.filterQmiAndHomePlans, this.qmiAndHomeplans);
    }
    this.separateCommunityPlans();
    this.sortByPrice();
    this.filterQmiAndHomePlans = this.filtersort(this.filterQmiAndHomePlans);
    this.updatefilteredHomePlans(this.filterQmiAndHomePlans);
    this.updateCountQmi();
    this.countNewHomePlans(this.filterQmiAndHomePlans.length);
    return this.filterQmiAndHomePlans;
  }

  sortPlans(homePlans, sortBy: string, sortDir: number) {
    return homePlans.sort((first, second) => {
      let field1 = "" as string | number;
      let field2 = "" as string | number;
      if (sortBy === SortOptions.PLAN) {
        field1 = first.plan_name.toLowerCase();
        field2 = second.plan_name.toLowerCase();
      } else {
        field1 = this.availableSites ? (first.price ?? first.price_low_with_premium): first.plan_name;
        field2 = this.availableSites ? (second.price ?? second.price_low_with_premium): second.plan_name;
      }
      if (sortDir === 1 || (!this.availableSites && sortBy === SortOptions.PRICE)) {
        return compareSortingValue(field1, field2);
      }
      return compareSortingValue(field2, field1);
    });
  }

  setQmiDaysMobileFilter(qmiDaysMobileFilter: QmiDays[]){
    this.qmiDaysMobileFilter = qmiDaysMobileFilter.slice(0);
    this.applyQmiDaysFilter(qmiDaysMobileFilter);
  }

  showQmiHomeplans(qmiFilter:boolean) {
    if (qmiFilter) {
      (this.selectedNeighborhoodQmiDetails) ? this.qmiAndHomeplans = this.selectedNeighborhoodQmiDetails : this.qmiAndHomeplans = [];
    } else {
      this.qmiAndHomeplans = (this.selectedNeighborhoodQmiDetails && !qmiFilter )? this.homeplans.concat(this.selectedNeighborhoodQmiDetails) : this.homeplans;
      this.setQmiFilterProperties([]);
    }
    this.addFutureHomePlan();
  }

  calculateDynamicHeight(height?: number) {
    const header = document.getElementById("header") as HTMLElement;
    const footer = document.getElementById("footer") as HTMLElement;
    const vh = height ? height : window.innerHeight;
    this.siderBarHeight = getSidebarHeight(vh, header, footer);
    this.toolbarTopPosition = getToolbarTopPosition(header);
  }

  setSorting(sortOption) {
    this.setSortProperties(sortOption.value);
    this.sortBy = sortOption.sortField;
    this.sortDir = sortOption.sortDirection;
    this.selectedSorting = sortOption.value;
  }

  compare(first: string | number, second: string | number) {
    if (first < second) {
      return -1;
    }
    if (first > second) {
      return 1;
    }
    return 0;
  }
  filterPlanNameHomeType(
    listHomeType: string[],
    listPlanName: string[],
    maxPrice: number,
    minPrice: number
  ) {
    this.listHomeType = listHomeType;
    this.listPlanName = listPlanName;
    this.maxPrice = maxPrice;
    this.minPrice = minPrice;
    this.setFilterProperties(listHomeType, listPlanName, maxPrice, minPrice);
  }
  isApplyPrice(){
    let currentNeighborhood: NeighborhoodSoldDetails[]=[];
    if(this.selectedNeighborhoodIds.length){
       currentNeighborhood = this.soldPercentage.filter((element) => element.neighborhoodId === this.selectedNeighborhoodIds[0]);
       return currentNeighborhood.length && currentNeighborhood[0].soldPercentage!==100 ;
    }else{
      currentNeighborhood = this.soldPercentage.filter((element) => element.soldPercentage !== 100);
      return currentNeighborhood.length;
    }
  }
  filterSortMediator(sortedHomePlanData) {
    let  filterQmiAndHomePlans= sortedHomePlanData;
    if(this.listHomeType.length)
    {
      filterQmiAndHomePlans = sortedHomePlanData.filter((homePlan)=>
      this.listHomeType.includes(homePlan.plan_type));
    }
    if(this.isApplyPrice() && !this.planPriceExsist){
      filterQmiAndHomePlans = filterQmiAndHomePlans.filter(
        (element) =>
          this.maxPrice >= (element.price ?? element.price_low_with_premium) &&
          this.minPrice <= (element.price ?? element.price_low_with_premium)
      );
    }
    const listTypeFilter = filterQmiAndHomePlans.filter((element)=>{
      const data= element.plan_market_name ?? element.plan_name;
      return this.listPlanName.includes(data)
    });
    if (listTypeFilter.length || this.listPlanName.length) {
      filterQmiAndHomePlans = listTypeFilter;
    }
    return filterQmiAndHomePlans;
  }
  filtersort(sortedHomePlanData) {
    if (
      !this.listHomeType.length &&
      !this.listPlanName.length &&
      !this.minPrice &&
      !this.maxPrice
    ) {
      return sortedHomePlanData;
    }
    return this.filterSortMediator(sortedHomePlanData);
  }
  filteredQmis(qmiFilterList: QmiDays[], currDate: Date) {
    const otherDaysFilter = qmiFilterList.filter((filter) => filter.days !== Settings.MaxValue);
    const qmisBeyondNinetyDays = this.selectedNeighborhoodQmiDetails.filter((plan:QmiDetails)=> dateDiffInDays(currDate,new Date(plan.move_in_date)) > 90);
    if (otherDaysFilter.length) {
      const maxDaysDifference = otherDaysFilter.reduce((r,qmi) => {return Math.max(r,qmi.days)},0);
      const remainingQmis = this.selectedNeighborhoodQmiDetails.filter((plan:QmiDetails)=> dateDiffInDays(currDate,new Date(plan.move_in_date)) <= maxDaysDifference);
      return qmisBeyondNinetyDays.concat(remainingQmis);
    }
    return qmisBeyondNinetyDays;
  }

  applyQmiDaysFilter(qmiFilterList: QmiDays[])
  {
    this.setQmiFilterProperties(qmiFilterList);
    const maxDaysDifference = qmiFilterList.reduce((r,qmi) => {return Math.max(r,qmi.days)},0);
    const currDate = new Date(new Date().toLocaleString("en-us", { timeZone: "America/Chicago" }));
    if (this.selectedNeighborhoodQmiDetails && maxDaysDifference) {
      this.qmiAndHomeplans = this.selectedNeighborhoodQmiDetails.filter((plan:QmiDetails)=> dateDiffInDays(currDate,new Date(plan.move_in_date)) <= maxDaysDifference)
      if (this.hasMobile) {
        this.qmiAppliedMobile = true;
      }
      if (maxDaysDifference === Settings.MaxValue) {
        this.qmiAndHomeplans = qmiFilterList.length === QmiDaysFilter.length ? this.qmiAndHomeplans : this.filteredQmis(qmiFilterList, currDate);
      }
    } else {
      this.qmiAndHomeplans = [];
      if (this.hasMobile) {
        this.qmiAppliedMobile = false;
      }
    }
  }

  clearQmiDaysFilter(isQmiSelected:boolean)
  {
    if(this.selectedNeighborhoodQmiDetails && isQmiSelected) {
      this.qmiAndHomeplans = this.selectedNeighborhoodQmiDetails;
    } else if(this.selectedNeighborhoodQmiDetails && !isQmiSelected) {
      this.qmiAndHomeplans = this.homeplans.concat(this.selectedNeighborhoodQmiDetails);
    } else if(!this.selectedNeighborhoodQmiDetails && !isQmiSelected) {
      this.qmiAndHomeplans = this.homeplans;
    }
    if (!isQmiSelected) {
      this.setQmiFilterProperties([]);
    }
  }
}
const getSidebarHeight = (vh, header, footer) => {
  return (
    vh -
    ((header ? header.clientHeight : 0) +
      (footer ? footer.clientHeight : 0) +
      getTopOuterHeight() +
      getBottomOuterHeight())
  );
};
const getToolbarTopPosition = (header) => {
  return (header && header.clientHeight ? header.clientHeight : 0) + getTopOuterHeight();
};
const getTopOuterHeight = () => {
  return isMobile && !isTablet
    ? Settings.TOP_OUTER_HEIGHT_MOBILE
    : Settings.TOP_OUTER_HEIGHT_TABLET;
};
const getBottomOuterHeight = () => {
  return isMobile && !isTablet
    ? Settings.BOTTOM_OUTER_HEIGHT_MOBILE
    : Settings.BOTTOM_OUTER_HEIGHT_TABLET;
};
